import { render, staticRenderFns } from "./ListMagazzino.vue?vue&type=template&id=08b7b049&"
import script from "./ListMagazzino.vue?vue&type=script&lang=js&"
export * from "./ListMagazzino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports